import {PlayerReduxState} from "../types";

export default function isRecognizing(state: PlayerReduxState): boolean {
  return state.isRecognizing;
}
